import React, { useState, useEffect } from 'react';
import { uploadAPI } from '../../lib/api';
import { UploadSimple, X, CheckCircle } from '@phosphor-icons/react';
import { toast } from 'sonner';

/**
 * Generic file uploader button.
 * onUploaded receives { file_id, url, filename, size }
 */
const FileUploader = ({ label, accept, currentFileId, currentFilename, onUploaded, onCleared, testId }) => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setProgress(0);
    try {
      const response = await uploadAPI.uploadFile(file, setProgress);
      onUploaded(response.data);
      toast.success(`${file.name} uploaded`);
    } catch (err) {
      toast.error(`Upload failed: ${err.response?.data?.detail || err.message}`);
    } finally {
      setUploading(false);
      setProgress(0);
      e.target.value = '';
    }
  };

  const hasFile = !!currentFileId;

  return (
    <div className="space-y-1">
      {label && <label className="block text-xs font-medium text-text_muted">{label}</label>}
      {hasFile ? (
        <div className="flex items-center justify-between p-2 border border-border bg-gray-50" data-testid={testId ? `${testId}-uploaded` : undefined}>
          <div className="flex items-center space-x-2 min-w-0">
            <CheckCircle size={16} weight="fill" className="text-green-600 flex-shrink-0" />
            <span className="text-xs truncate">{currentFilename || 'File uploaded'}</span>
          </div>
          {onCleared && (
            <button
              type="button"
              onClick={onCleared}
              className="p-1 hover:bg-red-100 rounded text-red-500"
              data-testid={testId ? `${testId}-clear` : undefined}
            >
              <X size={14} />
            </button>
          )}
        </div>
      ) : (
        <label className="flex items-center justify-center space-x-2 p-2 border border-dashed border-border cursor-pointer hover:border-accent hover:bg-gray-50 transition-colors" data-testid={testId}>
          <UploadSimple size={16} className="text-text_muted" />
          <span className="text-xs text-text_muted">{uploading ? `Uploading ${progress}%...` : 'Upload'}</span>
          <input type="file" accept={accept} onChange={handleUpload} disabled={uploading} className="hidden" />
        </label>
      )}
    </div>
  );
};

export default FileUploader;
